import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { Button, Field, Input, Select, Modal } from "@/components/ui-kit";
import { DatePicker } from "@/components/DatePicker";

/**
 * Manual SJ Modal — used by the Billing wizard Step 2 to create or edit
 * an ad-hoc Surat Jalan that lives only inside the invoice (not in the
 * surat_jalan collection). Pure presentational.
 */
export function ManualSjModal({
  open,
  onClose,
  manualForm,
  setManualForm,
  manualEditIdx,
  sjCodes,
  onSave,
}) {
  const setItem = (i, key, val) => {
    const items = [...(manualForm.items || [])];
    items[i] = { ...items[i], [key]: val };
    setManualForm({ ...manualForm, items });
  };
  const addItem = () =>
    setManualForm({
      ...manualForm,
      items: [...(manualForm.items || []), { material_name: "", unit: "", quantity: 1 }],
    });
  const rmItem = (i) =>
    setManualForm({ ...manualForm, items: manualForm.items.filter((_, j) => j !== i) });

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={manualEditIdx == null ? "Input SJ Manual" : "Edit SJ Manual"}
      size="lg"
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="No Surat Jalan" required hint="Pilih Kode SJ untuk prepend otomatis">
            <div className="flex gap-2">
              <Select
                className="!w-32 shrink-0"
                value=""
                onChange={(e) => {
                  if (e.target.value) setManualForm({ ...manualForm, sj_number: e.target.value + manualForm.sj_number });
                }}
                data-testid="manual-sj-code"
              >
                <option value="">Kode SJ</option>
                {sjCodes.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
              </Select>
              <Input
                value={manualForm.sj_number}
                onChange={(e) => setManualForm({ ...manualForm, sj_number: e.target.value })}
                data-testid="manual-sj-number"
                placeholder="Nomor / sisa kode"
              />
            </div>
          </Field>
          <Field label="Tanggal" required>
            <DatePicker
              value={manualForm.date}
              onChange={(e) => setManualForm({ ...manualForm, date: e.target.value })}
              data-testid="manual-sj-date"
            />
          </Field>
          <Field label="No Kendaraan">
            <Input
              value={manualForm.vehicle_no}
              onChange={(e) => setManualForm({ ...manualForm, vehicle_no: e.target.value })}
              data-testid="manual-sj-vehicle"
            />
          </Field>
          <Field label="Tujuan">
            <Input
              value={manualForm.delivery_location}
              onChange={(e) => setManualForm({ ...manualForm, delivery_location: e.target.value })}
              data-testid="manual-sj-dest"
            />
          </Field>
        </div>
        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="text-xs font-semibold uppercase tracking-wider text-stone-600">Item</label>
            <Button variant="secondary" className="!py-1 !px-2 text-xs" onClick={addItem}>
              <Plus className="h-3 w-3" />Tambah
            </Button>
          </div>
          <div className="border border-stone-200 divide-y divide-stone-100">
            {(manualForm.items || []).map((it, i) => (
              <div key={i} className="grid grid-cols-12 gap-2 p-2 items-center">
                <Input
                  className="col-span-6"
                  placeholder="Nama material"
                  value={it.material_name}
                  onChange={(e) => setItem(i, "material_name", e.target.value)}
                  data-testid={`manual-sj-item-name-${i}`}
                />
                <Input
                  className="col-span-3"
                  placeholder="Satuan"
                  value={it.unit}
                  onChange={(e) => setItem(i, "unit", e.target.value)}
                  data-testid={`manual-sj-item-unit-${i}`}
                />
                <Input
                  className="col-span-2 font-mono-num"
                  placeholder="Qty"
                  value={it.quantity}
                  onChange={(e) => setItem(i, "quantity", e.target.value)}
                  data-testid={`manual-sj-item-qty-${i}`}
                />
                <button
                  onClick={() => rmItem(i)}
                  className="col-span-1 text-stone-400 hover:text-red-700"
                >
                  <Trash2 className="h-3.5 w-3.5 mx-auto" />
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-3 border-t border-stone-200">
          <Button variant="ghost" onClick={onClose}>Batal</Button>
          <Button onClick={onSave} data-testid="manual-sj-save-btn">Simpan</Button>
        </div>
      </div>
    </Modal>
  );
}
